import React, { useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';

import { GridGetterFunction } from '../../../common/components/Grid/GridDataTypes';
import {
  CreateUpdateParamsDto,
  GetParamsDto,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { ParamsEditor } from '../../../app/components/Params/ParamsEditor';
import { ParamsSearch } from '../../../app/components/Params/ParamsSearch';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import {
  convert,
  validate,
} from '../../../common/spdCore/contexts/ParamsContext';

export const ParamsView: React.FC = () => {
  const [param, setParam] = useState<GetParamsDto>();
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const spd = useSpdCore();

  const editParam = async (paramCU: CreateUpdateParamsDto, id: string) => {
    const validationResult = await validate(paramCU);
    if (validationResult.valid) {
      try {
        await spd.params.update(id, paramCU);
        setShow(false);
        setRefresh(!refresh);
        return {
          saved: true,
          errors: [],
        };
      } catch (response) {
        return {
          saved: false,
          errors: await responseErrors(response as ResponseError),
        };
      }
    } else {
      return {
        saved: false,
        errors: validationResult.errors,
      };
    }
  };

  const onRowClick = async (id: string) => {
    const getParam = await spd.params.getById(id);
    setParam(getParam);
    setShow(true);
  };

  const handleClose = () => {
    setParam(undefined);
    setShow(false);
  };

  const getData = useMemo(
    () =>
      ((
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ) =>
        spd.params.getAllByPortion(
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          filterColumns,
        )) as GridGetterFunction,
    [spd],
  );

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">Parametry</Card.Title>
        <ParamsSearch
          getData={getData}
          getCount={spd.params.getAllCount}
          onRowClick={onRowClick}
          refresh={refresh}
        />
        {param && (
          <ParamsEditor
            param={convert(param)}
            readOnly={!param.isEditable}
            show={show}
            handleClose={handleClose}
            onCompleted={editParam}
            id={param.id}
          />
        )}
      </Card.Body>
    </Card>
  );
};
